<template>
    <section class="section-content article">
      <div class="header height" style="background-color: transparent"></div>
      <b-container class="static mb-4">
        <b-card no-body class="overflow-hidden">
          <b-row no-gutters>
            <b-col lg="3" style="background-color: #f0f2f7;">
              <b-list-group flush>
                <b-list-group-item class="new-col-bg" :to="{ path: '/articles?address=0x9b7856db6dc27822bfb72f412ace95758cc448c7'}"> <b>Evrice official</b></b-list-group-item>
                <b-list-group-item class="new-col-bg" :to="{ path: '/articles'}"><b>{{ $t('article.ln_5') }}</b><b-badge style="font-size: 15px; border-color: transparent; background-color: transparent" class="float-right" >{{ count }}</b-badge></b-list-group-item>
                <b-list-group-item v-if="logget" class="new-col-bg" :to="{ path: '/articles/editor/0'}"><b>{{ $t('article.ln_10') }}</b></b-list-group-item>
              </b-list-group>

            </b-col>
            <b-col class="col-ground" lg="9">
              <b-card-body>
                <router-view />
              </b-card-body>
					</b-col>
				</b-row>
			</b-card>
		</b-container>
    </section>
</template>

<script lang="js">

    import axios from "axios";
    import api from "../../libs/api";

    export default {
        name: "article.main",
        data() {
            return {
                logget: false,
                count: 0,
            }
        },
		watch: {
			$route() {
				// Get counts tabs article.
				this.getCount();
			}
		},
        mounted() {
            this.$store.dispatch('getLocalStorageObject', 'account').then((account) => {
                this.$data.logget = !!account;
            });
        },
        created() {

            // Get counts tabs article.
            this.getCount();
        },
        methods: {
            getCount() {
                axios.post(api.article.list, {address: this.$route.query.address}).then((response) => {
                    if (response.data.source !== undefined) {
                        this.$data.count = response.data.count;
                    } else {
                        this.$data.count = 0;
                    }
                }).catch((error) => {
					this.$bvToast.toast(`${error.response.data.code}: ${error.response.data.message}`, {
						title: this.$t('error.ln_5'),
						autoHideDelay: 5000,
						toaster: 'b-toaster-bottom-right',
						variant: 'danger',
					});
                });
            }
        }
    }
</script>

<style scoped>

</style>